import { XMarkIcon } from "@heroicons/react/24/outline";

export const DialogMenu = ({ children, dialogRef }) => {
    return (
        <dialog ref={dialogRef} closedBy="any">
            <div className="fixed top-0 right-0 p-0 bg-white dark:bg-gray-900 text-black dark:text-white w-[482px] h-screen shadow-lg overflow-auto ">
                <button
                    className="absolute top-4 right-4 text-white rounded-lg hover:bg-white/30 transition-all"
                    onClick={() => dialogRef.current?.close()}
                >
                    <XMarkIcon className="h-8 w-8" />
                </button>
                {children}
            </div>
        </dialog>
    );
};